export default "__VITE_ASSET__82010d8c__"